import { createSlice } from '@reduxjs/toolkit';

const platformAvatars = createSlice({
  name: 'platformAvatars',
  initialState: [],
  reducers: {
    setPlatformAvatars: (
      _,
      action
    ) => action.payload,
  },
});

export const { setPlatformAvatars } = platformAvatars.actions;
export const platformAvatarsReducer = platformAvatars.reducer;
